import {CreateProjectPayloadType} from '../components/pages/project-creation/CreateProject/types/createProjectTypes';
import apiClient from './index';

const version = 'v1';
const selectiveSelfManagementEndpoint = (path: string) =>
  `${version}/selectiveselfmanagement/${path}`;

export const getBudgetTrackerDetails = (
  clientId: string,
  projectId: string
) => {
  return apiClient.get(
    selectiveSelfManagementEndpoint(
      `clients/${clientId}/projects/${projectId}/budget-detail`
    )
  );
};

export const getBudgetTrackerAlert = (clientId: string) => {
  return apiClient.get(
    selectiveSelfManagementEndpoint(`budget-alert/client/${clientId}`)
  );
};

export const removeBudgetTrackerAlert = (budgetAlertReportId: number) => {
  return apiClient.put(
    selectiveSelfManagementEndpoint(
      `budget-alert/${budgetAlertReportId}/status/viewed`
    )
  );
};

export const createProject = (params: CreateProjectPayloadType) => {
  const endpoint = selectiveSelfManagementEndpoint(`project`);
  return apiClient.post(endpoint, params);
};

export const getProjectStatusDetail = (params: {
  clientId: string;
  auroraProjectId: string;
}) => {
  return apiClient.get(selectiveSelfManagementEndpoint(`project/status`), {
    params: params,
  });
};

export const getProjectMarketingVideo = async (): Promise<Blob> => {
  const {data} = await apiClient.get(
    selectiveSelfManagementEndpoint(`project/marketing-video`),
    {responseType: 'blob'}
  );
  return data;
};

export const getProjectMarketingVideoThumbnail = async (): Promise<Blob> => {
  const {data} = await apiClient.get(
    selectiveSelfManagementEndpoint(`project/marketing-video/thumbnail`),
    {responseType: 'blob'}
  );
  return data;
};
